<div class="login-mfa-code-input-section">
    <div class="login-main-body-desc">
        A 6 character verification code has been sent to the device you selected. Please enter it below.
    </div>
    <div class="login-title-ctr">
        <app-alert-error *ngIf="isInvalidCode" [wide]="true">Your entry is incorrect</app-alert-error>
        <app-alert-error *ngIf="isExpiredRequest">Your request has expired. Please refresh the page and try again.</app-alert-error>
        <app-alert-error *ngIf="isLockedOut" [wide]="true">Too many incorrect entries</app-alert-error>
    </div>
    <div class="login-mfa-code-fields-container">
        <ng-container *ngFor="let formControl of formArray.controls; let formControlIndex = index">
            <input
                #codeInput
                [formControl]="formControl"
                (paste)="onPaste($event)"
                (keydown)="onKeydown(formControlIndex, $event)"
                (input)="onInput(formControlIndex, $event)"
                matInput
                maxlength="1"
                type="text"
                autocomplete="off"
                class="login-mfa-code-field" />
        </ng-container>
    </div>
    <div class="login-mfa-code-countdown-container">
        You have <app-countdown class="login-mfa-code-countdown" (completed)="onCountdownCompleted()"></app-countdown> minutes left.
    </div>
</div>